function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgIconOrderClosed = function SvgIconOrderClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#00B427",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 50,
    r: 40,
    fill: "#00B427",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 22,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#00B427"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15887_82661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 49.7388L48.4766 56.3077L58.5 44",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15887_82661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(40.5 40)"
  }))));
};
export default SvgIconOrderClosed;